import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Add } from './scenes/Add'
import { Edit } from './scenes/Edit'
import { List } from './scenes/List'

export const Addresses = () => {
  return (
    <Switch>
      <Route
        exact
        path='/customer/account/addresses'
        component={List}
      />

      <Route
        exact
        path='/customer/account/addresses/add'
        component={Add}
      />

      <Route
        exact
        path='/customer/account/addresses/edit/:id'
        component={Edit}
      />

      <Redirect
        to='/customer/account/addresses'
      />
    </Switch>
  )
}
